"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.durationToMilliseconds = durationToMilliseconds;
exports.detectorDefs = detectorDefs;
exports.detectorDefToIds = detectorDefToIds;
function durationToMilliseconds(delay) {
    if (!delay) {
        return 0;
    }
    const conversions = {
        S: 1000,
        M: 1000 * 60,
        H: 1000 * 60 * 60,
    };
    return delay.value * conversions[delay.unit];
}
function detectorDefs(def) {
    if (!def) {
        return [];
    }
    return [def].flat();
}
function detectorDefToIds(def) {
    return detectorDefs(def).map((d) => d.detectorId);
}
//# sourceMappingURL=utils.js.map